import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface MetricButton {
  label: string;
  link: string;
}

export enum PmpMetricReportKey {
  Metric1 = "PmpMetric1",
  Metric2AccountLevel = "PmpMetric2AccountLevel",
  Metric2TaskLevel = "PmpMetric2TaskLevel",
  Metric3 = "PmpMetric3",
  Metric4AccountLevel = "PmpMetric4AccountLevel",
  Metric4ProcedureChangeLog = "PmpMetric4ProcedureChangeLog",
  Metric5 = "PmpMetric5",
  Metric6 = "PmpMetric6",
}

export const PmpMetricButtons: MetricButton[] = [
  { label: "Metric 1", link: PmpMetricReportKey.Metric1 },
  { label: "Metric 2_Account Level", link: PmpMetricReportKey.Metric2AccountLevel },
  { label: "Metric 2_Task Level", link: PmpMetricReportKey.Metric2TaskLevel },
  { label: "Metric 3", link: PmpMetricReportKey.Metric3 },
  { label: "Metric 4_Account Level", link: PmpMetricReportKey.Metric4AccountLevel },
  { label: "Metric 4_Procedure Change Log", link: PmpMetricReportKey.Metric4ProcedureChangeLog },
  { label: "Metric 5", link: PmpMetricReportKey.Metric5 },
  { label: "Metric 6", link: PmpMetricReportKey.Metric6 },
];

// TEMPORARY (PMP-4505): remove `DATA_NOT_GENERATED_BANNER_CUTOVER_UTC8`, `getCurrentUTC8Date`,
// `shouldShowDataNotGeneratedBanner`, `DATA_NOT_GENERATED_BANNER_TITLE`,
// `DATA_NOT_GENERATED_BANNER_MESSAGE`, and their usage in `index.tsx` / `index.module.scss` once
// the first PMP Monitoring Report data load (2026 Q3) has gone out.
// Cutover: 2026-11-10 00:00:00 UTC+8.
const DATA_NOT_GENERATED_BANNER_CUTOVER_UTC8 = new Date(2026, 10, 10, 0);

// Returns the current date/hour in UTC+8.
export const getCurrentUTC8Date = (): Date => {
  const nowUtc8 = dayjs.utc().add(8, "hour");
  return new Date(nowUtc8.year(), nowUtc8.month(), nowUtc8.date(), nowUtc8.hour());
};

export const shouldShowDataNotGeneratedBanner = (
  referenceDate: Date = getCurrentUTC8Date()
): boolean => referenceDate.getTime() < DATA_NOT_GENERATED_BANNER_CUTOVER_UTC8.getTime();

export const DATA_NOT_GENERATED_BANNER_TITLE = "Data has not yet been generated";
export const DATA_NOT_GENERATED_BANNER_MESSAGE =
  " - The first data load, covering 2026 Q3, is scheduled for 11/10/2026. Until then, this section will appear blank. Please check back after that date.";
